import { MyReduxStore } from 'ha/myredux/types';

import { STATE_NAME } from './constants';
import SearchRoot from './containers/SearchRoot';
import reducer from './reducer';

export default (store: MyReduxStore): React.ReactNode => {
  store.injectAsyncReducer(STATE_NAME, reducer);
  return SearchRoot;
};
